export enum CommitmentCodeEnum {
  ChildSponsorship = 'DS',
  CenterGift = 'PG',
  BirthdayGift = 'BG',
  FamilyGift = 'FG',
  FinalGift = 'FLG',
  ChildGift = 'GG',
  Unsponsored = 'UC',
  Disaster = 'ER',
  HighlyVulnerableChildren = 'OV',
  GlobalFoodCrisis = 'GFC',
  HIVDisease = 'HA',
  ChildSurvival = 'MF',
  HealthNutrition = 'NH',
  ChristmasGift = 'CF',
  MedicalAssistance = 'MA',
  Education = 'ED',
  WaterSanitation = 'WP',
}
